import React, {useState, useEffect }  from 'react';
import { render } from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Link } from 'react-router-dom';
import Header from './Shared/Header';
import Footer from './Shared/Footer';
import Home from './Pages/Home';


import Explore from './Pages/CollaborativeWorkingAndLearningSpaces';
import CollaborativeWorkingAndLearningSpaces from './Pages/CollaborativeWorkingAndLearningSpaces';
import ComputerAndTechnology from './Pages/ComputerAndTechnology';
import PrintingScanningAndPhotocopying from './Pages/PrintingScanningAndPhotocopying';
import LibraryService from './Pages/LibraryService';
import MakerSpace from './Pages/MakerSpace';


import FindResources from './Pages/FindResources';
import FreeOpenAccessResources from './Pages/FreeOpenAccessResources';
import NewspaperMagazine from './Pages/NewspaperMagazine';
import EresourcesDatabases from './Pages/EresourcesDatabases';
import AHSS from './Pages/EresourcesDatabases/AHSS';
import DSSE from './Pages/EresourcesDatabases/DSSE';


import ResearchSupport from './Pages/ResearchSupport';
import BookSession from './Pages/BookSession';
import EventCalendar from './EventCalendar';
import SelfLearningResources from './Pages/SelfLearningResources';

import About from './Pages/About';
import LibraryHours from './Pages/LibraryHours';
import InternshipAndStudentEmploymentOpportunities from './Pages/InternshipAndStudentEmploymentOpportunities';

import PatronUserPolicies from './Pages/BorrowingPolicies';
import BorrowingPolicies from './Pages/BorrowingPolicies';
import ComputerUsePolicy from './Pages/ComputerUsePolicy';
import DiscussionRoomsPolicy from './Pages/DiscussionRoomsPolicy';
import LibrarySpaces from './Pages/LibrarySpaces';
import FinesPenalty from './Pages/FinesPenalty';
import Compliance from './Pages/Compliance';

import AskaLibrarian from './Pages/AskaLibrarian';
import Faq from './Pages/Faq';
import ResourceRequest from './Pages/ResourceRequest';
import RightsandResponsibilities from './Pages/RightsandResponsibilities';
import Eresources from './Pages/SubPages/Eresources';
import LearningSpaces from './Pages/LearningSpaces';
import TodayEvents from './Component/TodayEvents';
import GoogleSearch from './Component/GoogleSearch';
import SearchResults from './Component/SearchResults';
import LibraryServices from './Pages/LibraryServices';

// import JotFormComponent from './Component/JotFormComponent';

function App(){
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    setTimeout(() =>{
        setLoading(false)
    },2000)
  }, [])
  return(
  <div className='home-wrapper'>
    {
    loading ?
      <div className='spinner'>
      <div className='inner-spinner'>
        <img src='https://habib.edu.pk/dev-library/assets/img/preloader.gif'/>
      </div>
      </div>
    :
    
    <BrowserRouter basename={'/dev-library'}>  
      <Header/>
        <Routes>
        
          <Route exact path="/" element={<Home/>}/>

          {/* <Route exact path="/Explore" element={<CollaborativeWorkingAndLearningSpaces/>}/> */}
          <Route exact path="/CollaborativeWorkingAndLearningSpaces" element={<CollaborativeWorkingAndLearningSpaces/>}/>
          <Route exact path="/ComputerAndTechnology" element={<ComputerAndTechnology/>}/>
          <Route exact path="/PrintingScanningAndPhotocopying" element={<PrintingScanningAndPhotocopying/>}/>
          <Route exact path="/LibraryService" element={<LibraryService/>}/>
          <Route exact path="/MakerSpace" element={<MakerSpace/>}/>

  {/* Find Resources */}
          <Route path="/FindResources" element={<FindResources />} />
          <Route path="/FreeOpenAccessResources" element={<FreeOpenAccessResources />} />
          <Route path="/NewspaperMagazine" element={<NewspaperMagazine/>}/>
          <Route path="/EresourcesDatabases" element={<EresourcesDatabases/>}/>
          <Route path="/AHSS" element={<AHSS/>}/>
          <Route path="/DSSE" element={<DSSE/>}/>

          <Route  path="/ResearchSupport" element={<ResearchSupport/>}/>                
          <Route  path="/BookSession" element={<BookSession/>}/>
          <Route  path="/EventCalendar" element={<EventCalendar/>}/>
          <Route  path="/SelfLearningResources" element={<SelfLearningResources/>}/>

          <Route  path="/About" element={<About/>}/>
          <Route  path="/LibraryHours" element={<LibraryHours/>}/>
          <Route  path="/InternshipAndStudentEmploymentOpportunities" element={<InternshipAndStudentEmploymentOpportunities/>}/>
          
          {/* <Route  path="/PatronUserPolicies" element={<PatronUserPolicies/>}/> */}
          <Route  path="/BorrowingPolicies" element={<BorrowingPolicies/>}/>
          <Route  path="/ComputerUsePolicy" element={<ComputerUsePolicy/>}/>
          <Route  path="/DiscussionRoomsPolicy" element={<DiscussionRoomsPolicy/>}/>
          <Route  path="/LibrarySpaces" element={<LibrarySpaces/>}/>
          <Route  path="/FinesPenalty" element={<FinesPenalty/>}/>
          <Route  path="/Compliance" element={<Compliance/>}/>



          <Route exact path="/Eresources" element={<Eresources/>}/>
          <Route exact path="/LearningSpaces" element={<LearningSpaces/>}/>
          <Route exact path="/AskaLibrarian" element={<AskaLibrarian/>}/>
          <Route exact path="/Faq" element={<Faq/>}/>
          <Route exact path="/ResourceRequest" element={<ResourceRequest/>}/>
          <Route exact path="/RightsandResponsibilities" element={<RightsandResponsibilities/>}/>
          <Route exact path="/GoogleSearch" element={<GoogleSearch/>}/>
          <Route exact path="/SearchResults" element={<SearchResults/>}/>
          <Route exact path="/LibraryServices" element={<LibraryServices/>}/>
          <Route exact path="/TodayEvents" element={<TodayEvents/>}/>
          
          
        </Routes>
      <Footer/>
    </BrowserRouter>
      }
  </div>
);
}

  render(<App />, document.getElementById('root'));


